export enum LinkVariants {
  MAIN = 'main',
  CANCEL_OUTLINED = 'cancel_outlined',
  TRANSPARENT = 'transparent',
}
